export default __webpack_public_path__ + "fonts/u-wuoqret9fueobqw7jkracwcynf_cdxxwclxiixg1c-webfont.woff";